import moment from "moment";

// Mirrors controller/pdfFieldResolver.js on the backend. Keep in sync.
// Preview data object (from /pdf-preview-data endpoint):
//   { trainingStartDate, trainingEndDate, eventAddress, companyName,
//     companyAddress, companyAddressFontSize, noOfPax, totalPrice,
//     pricePerPax, priceDisplay, noOfAllocateParticipantDisplay }

const resolvers = {
  today: (_, fmt) => moment().format(fmt || "Do MMMM YYYY"),
  trainingStartDate: (d) => d.trainingStartDate || "",
  trainingStartDateFormatted: (d, fmt) =>
    d.trainingStartDate
      ? moment(d.trainingStartDate, "YYYY-MM-DD").format(fmt || "Do MMMM YYYY")
      : "",
  trainingEndDate: (d) => d.trainingEndDate || "",
  trainingEndDateFormatted: (d, fmt) =>
    d.trainingEndDate
      ? moment(d.trainingEndDate, "YYYY-MM-DD").format(fmt || "Do MMMM YYYY")
      : "",
  trainingEndDatePlus1Formatted: (d, fmt) =>
    d.trainingEndDate
      ? moment(d.trainingEndDate, "YYYY-MM-DD")
          .add(1, "days")
          .format(fmt || "DD/MM/YYYY")
      : "",
  trainingStartDatePlus1Formatted: (d, fmt) =>
    d.trainingStartDate
      ? moment(d.trainingStartDate, "YYYY-MM-DD")
          .add(1, "days")
          .format(fmt || "DD/MM/YYYY")
      : "",
  trainingDateRange: (d, fmt) => {
    if (!d.trainingStartDate || !d.trainingEndDate) return "";
    const f = fmt || "DD/MM/YYYY";
    const s = moment(d.trainingStartDate, "YYYY-MM-DD").format(f);
    const e = moment(d.trainingEndDate, "YYYY-MM-DD").format(f);
    return `${s} - ${e}`;
  },
  trainingDateRangeStartTwice: (d, fmt) => {
    if (!d.trainingStartDate) return "";
    const f = fmt || "DD/MM/YYYY";
    const s = moment(d.trainingStartDate, "YYYY-MM-DD").format(f);
    return `${s} - ${s}`;
  },
  trainingDateOrdinalCombo: (d) => {
    if (!d.trainingStartDate || !d.trainingEndDate) return "";
    const start = moment(d.trainingStartDate, "YYYY-MM-DD").format("Do");
    const end = moment(d.trainingEndDate, "YYYY-MM-DD").format("Do MMMM YYYY");
    return `${start} & ${end}`;
  },
  eventAddress: (d) => d.eventAddress || "",
  eventAddressOneLine: (d) =>
    typeof d.eventAddress === "string"
      ? d.eventAddress.replace(/\r?\n/g, " ")
      : "",
  companyName: (d) =>
    d.companyName ? String(d.companyName).toUpperCase().replace(/\n/g, "") : "",
  companyNameAddress: (d) => {
    if (!d.companyName && !d.companyAddress) return "";
    return `${(d.companyName || "").toUpperCase()}\n${(d.companyAddress || "").toUpperCase()}`;
  },
  price: (d) => d.priceDisplay || "",
  noOfAllocateParticipant: (d) => d.noOfAllocateParticipantDisplay || "",
  totalFeeApproved: (d) => (d.totalPrice != null ? String(d.totalPrice) : ""),
  totalFeeClaimed: (d) => (d.totalPrice != null ? String(d.totalPrice) : ""),
  numberOfTrainee: (d) => (d.noOfPax != null ? String(d.noOfPax) : ""),
};

export const TOKEN_TAKES_FORMAT = {
  today: true,
  trainingStartDate: false,
  trainingStartDateFormatted: true,
  trainingEndDate: false,
  trainingEndDateFormatted: true,
  trainingEndDatePlus1Formatted: true,
  trainingStartDatePlus1Formatted: true,
  trainingDateRange: true,
  trainingDateRangeStartTwice: true,
  trainingDateOrdinalCombo: false,
  eventAddress: false,
  eventAddressOneLine: false,
  companyName: false,
  companyNameAddress: false,
  price: false,
  noOfAllocateParticipant: false,
  totalFeeApproved: false,
  totalFeeClaimed: false,
  numberOfTrainee: false,
};

export function resolveTokenValue(tokenId, format, data) {
  const fn = resolvers[tokenId];
  if (!fn) return "";
  try {
    return fn(data || {}, format) || "";
  } catch (_) {
    return "";
  }
}
